import { createContext, useContext } from 'react';

export type DashboardChartHeadingLevel = 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

const DashboardChartHeadingLevelContext = createContext<DashboardChartHeadingLevel>('h2');

export const DashboardChartHeadingLevelProvider = DashboardChartHeadingLevelContext.Provider;

export function useDashboardChartHeadingLevel(): DashboardChartHeadingLevel {
    return useContext(DashboardChartHeadingLevelContext);
}
